import React, { useState } from 'react'
import { expand } from '../../Images/Icons';
import ReactApexChart from "react-apexcharts";
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const RevenueSection = (props) => {
    // console.log(props.state)
    const navigation = useNavigate();
    const [state, setNewState] = useState({
        series: [{
            name: 'Revenue',
            color: '#58B9FF',
            data: [31, 40, 28]
        }],
        options: {
            chart: {
                height: 350,
                type: 'bar'
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            stacked: true,
            xaxis: {
                type: 'category',
                categories: props.legend,        
                tickAmount: 6 // Ensure only 6 ticks are shown
            },
            tooltip: {
                x: {
                    format: 'dd/MM/yy HH:mm'
                },
            },

        },
    });

    const setState = data => {
        setNewState(prev => ({ ...prev, ...data }))
    }

    const showElectricityPrice = () => {
        navigation('/home/statistic/electricityprice');
    }
    

    const { series, options } = state;

    
    useEffect(() => {
        setNewState({
            series: [{
                name: 'Revenue',
                color: '#58B9FF',
                data: props.revenue
            }],
            options: {
                chart: {
                    height: 350,
                    type: 'bar'
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth'
                },
                
                stacked: true,
                xaxis: {
                    type: 'category',
                    categories: props.legend,        
                    tickAmount: 8 // Ensure only 6 ticks are shown
                },
                tooltip: {
                    x: {
                        format: 'dd/MM/yy HH:mm'
                    },
                },
                legend: {
                    show: false
                  }
    
            }
        });
    }, [props.revenue]);

    return (
        <div>
            <div style={{ margin: 20, background: 'white', borderRadius: 12, padding: 16 }}>
                <div style={{ fontSize: 16, fontWeight: 500, color: '#161616', textAlign: 'center' }}>Revenue</div>
                <div onClick={showElectricityPrice} style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 45 }}>
                    <div>
                        <div style={{ fontSize: 14, fontWeight: 500, color: '#161616' }}>Total Revenue</div>
                        <div style={{ fontSize: 20, fontWeight: 500, color: '#161616', display: 'flex', alignItems: 'center' }}><span style={{ fontSize: 12, color: '#7b7b7b', marginRight: 4 }}>Rp</span>{new Intl.NumberFormat('de-DE').format(props.state.Sum_Revenue.toFixed(0))}</div>
                    </div>
                    <div style={{
                        width: 125, height: 25, background: '#EEFFF9', color: '#006B34', fontWeight: 500, fontSize: 10,
                        borderRadius: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'
                    }}>Set Electricity Prices</div>
                </div>
                <div style={{width: '10%',height:39, marginTop:20, top:0,zIndex:100, position:'relative',background:'#fff', fontSize:'12px',color:'#7B7E87', paddingLeft:10, paddingTop:10}}>Rp</div>

                <div style={{ marginTop: -30, display: 'flex', justifyContent: 'end', position:'relative', top:25, zIndex:99 }}>
                    {/* <div style={{
                        width: 100, height: 25, border: 'solid 1px #A8DCCA', borderRadius: 12, display: 'flex', justifyContent: 'center', alignItems: 'center',
                        color: '#006B34', fontSize: 10, fontWeight: 500, cursor: 'pointer'
                    }}>Full Screen <img src={expand} alt="" style={{ marginLeft: 4 }} /></div> */}
                </div>
                <div id="chart-area" style={{ marginTop: 12 }}>
                    <ReactApexChart options={options} series={series} type="bar" height={280} />
                </div>
            </div>

        </div>
    )
}

export default RevenueSection